<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa icon-speech text-primary mr-2"></i>
                    Notificaciones
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Listado
                    <export-actions :rows="getNotificationsFilteredData()"></export-actions>
                </b-row>

                <b-row>
                    <b-col sm="3">
                        <b-form-group
                            label="<strong>Tipo</strong>"
                            label-for="type"
                            :horizontal="false">
                            <multiselect
                                id="type"
                                v-model="filters.type"
                                :options="notificationTypesOptions.map(option => option.value)"
                                :customLabel="value => (notificationTypesOptions.find(option => option.value === value).text)"
                                :multiple="false"
                                :allowEmpty="true"
                                placeholder="Seleccione"
                                selectedLabel=""
                                selectLabel=""
                                deselectLabel="">
                            </multiselect>
                        </b-form-group>
                    </b-col>

                    <b-col sm="3">
                        <b-form-group
                            label="<strong>Estado</strong>"
                            label-for="status"
                            :horizontal="false">
                            <multiselect
                                id="status"
                                v-model="filters.isRead"
                                :options="isReadOptions.map(option => option.value)"
                                :customLabel="value => (isReadOptions.find(option => option.value === value).text)"
                                :multiple="false"
                                :allowEmpty="true"
                                placeholder="Seleccione"
                                selectedLabel=""
                                selectLabel=""
                                deselectLabel="">
                            </multiselect>
                        </b-form-group>
                    </b-col>

                    <b-col sm="3">
                        <b-form-group
                            label="<strong>Fecha de Inicio</strong>"
                            label-for="startDate"
                            :horizontal="false">
                            <v-date-picker
                                id="startDate"
                                v-model='filters.startDate'
                                class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                                :required="false"></v-date-picker>
                        </b-form-group>
                    </b-col>

                    <b-col sm="3">
                        <b-form-group
                            label="<strong>Fecha de Fin</strong>"
                            label-for="endDate"
                            :horizontal="false">
                            <v-date-picker
                                id="endDate"
                                v-model='filters.endDate'
                                class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                                :required="false"></v-date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col sm="12">
                        <v-client-table
                            ref="notificationsTable"
                            class="dataTable"
                            sm="12"
                            :columns="columns"
                            :data="filteredNotifications"
                            :options="options"
                            theme="bootstrap4">

                            <template slot="createdAt" slot-scope="props">
                                {{props.row.createdAt | dateFormat('DD/MM/YYYY HH:mm')}}
                            </template>

                            <template slot="isRead" slot-scope="props">
                                <template v-if="props.row.isRead">Si</template>
                                <template v-else>No</template>
                            </template>
                        </v-client-table>
                    </b-col>
                </b-row>

            </b-card>
        </b-row>

        <b-modal
            ref="newNotification"
            title="Enviar Notificación"
            size="lg"
            hide-footer>
            <user-notification-form
                :headquarters="notificationHeadquarters"
                :users="notificationUsers"
                :initialNotification="{message: null, headquarters: null, department: null, users: []}"
                :renderSaveButton="mixinCheckPermission('NOTIFICATION_NEW')"
                class="px-4 py-3"
                @submit-notification="sendNotification($event)">
                Enviar
            </user-notification-form>
        </b-modal>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Vue from 'vue';
    import form from '@/helpers/form';
    import Multiselect from 'vue-multiselect';
    import {ClientTable} from 'vue-tables-2';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import {getNotifications, createNotification} from '@/api/notification-api';
    import {getHeadquarters} from '@/api/headquarters-api';
    import {getUsers} from '@/api/user-api';
    import ExportActions from '@/components/ExportActions';
    import UserNotificationForm from '@/components/users/notifications/UserNotificationForm';
    import {getNotificationsTypesOptions} from '@/helpers/notification-helper';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    Vue.use(ClientTable);

    export default {
        name: "ListNotifications",
        components: {
            'v-date-picker': DatePicker,
            Multiselect,
            ExportActions,
            UserNotificationForm
        },
        data: () => {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Nueva Notificacion',
                        emit: 'new-notification',
                        brand: 'fa icon-speech',
                        permissions: ['NOTIFICATION_NEW']
                    }
                ],
                columns: ['createdAt', 'message', 'isRead'],
                options: {
                    headings: {
                        createdAt: 'Fecha',
                        message: 'Mensaje',
                        isRead: 'Leida',

                    },
                    sortable: ['createdAt'],
                    filterable: [],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    texts: null,
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                notifications: [],
                filters: {
                    type: null,
                    isRead: null,
                    startDate: null,
                    endDate: null,
                },
                isReadOptions: [
                    {
                        value: 1,
                        text: 'Leidas'
                    },
                    {
                        value: 2,
                        text: 'No Leidas'
                    }
                ],
                newNotification: {
                    headquarters: null,
                    department: null,
                    users: []
                },
                headquarters: null,
                users: null
            }
        },
        created() {
            this.getAllNotifications();
            this.getHeadquarters();
            this.getUsers();
        },
        mounted() {
            this.$eventHub.$on('new-notification', event => {
                this.$refs.newNotification.show();
            });

            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.options.texts = form.tableLabels();
        },
        computed: {
            notificationTypesOptions() {
                return getNotificationsTypesOptions();
            },
            filteredNotifications() {
                return this.notifications.filter(notification => {
                    return (
                        (!this.filters.type || notification.type === this.filters.type)
                        && (!this.filters.isRead || notification.isRead === (this.filters.isRead !== 2))
                        && (!this.filters.startDate || notification.createdAt >= this.filters.startDate)
                        && (!this.filters.endDate || notification.createdAt <= this.filters.endDate)
                    );
                });
            },
            notificationHeadquarters() {
                if (Array.isArray(this.headquarters)) {
                    return this.headquarters.filter((headquarters) => (this.isUserHeadquarters(headquarters.uuid)));
                } else {
                    return [];
                }
            },
            notificationUsers() {
                if (Array.isArray(this.users)) {
                    return this.users.filter((user) => (this.authUser().uuid !== user.uuid));
                } else {
                    return [];
                }
            }
        },
        methods: {
            ...mapGetters([
                'authUser',
            ]),
            async getHeadquarters() {
                this.$_loadingMixin_showLoading();
                await getHeadquarters()
                    .then((headquarters) => {
                        this.headquarters = headquarters;
                    })
                    .catch(() => {
                        this.headquarters = [];
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getUsers() {
                this.$_loadingMixin_showLoading();
                await getUsers()
                    .then((users) => {
                        this.users = users;
                    })
                    .catch(() => {
                        this.users = [];
                    });
                this.$_loadingMixin_hideLoading();
            },
            isUserHeadquarters(headquartersUuid) {
                return !!this.authUser().headquarters.find((headquarters) => (headquarters.uuid === headquartersUuid));
            },
            async getAllNotifications() {
                this.$_loadingMixin_showLoading();
                await getNotifications()
                    .then((notifications) => {
                        this.notifications = notifications;
                    });
                this.$_loadingMixin_hideLoading();
            },
            getNotificationsFilteredData() {
                if (!!this.filteredNotifications) {
                    return this.filteredNotifications.map(notification => ({
                        'Fecha': new Date(notification.createdAt).toLocaleDateString() + " " + new Date(notification.createdAt).toLocaleTimeString(),
                        'Mensaje': notification.message,
                        'Leido': notification.isRead ? "Si" : "No",
                    }));
                } else {
                    return [];
                }
            },
            async sendNotification(notification) {
                if (this.isValidNotification(notification)) {
                    this.$_loadingMixin_showLoading();

                    let headquartersId = (!!notification.headquarters && !!notification.headquarters.uuid)
                        ? notification.headquarters.uuid
                        : null;
                    let departmentId = (!!notification.department && !!notification.department.uuid)
                        ? notification.department.uuid
                        : null;
                    let userIds = (Array.isArray(notification.users))
                        ? notification.users.map(user => (user.uuid))
                        : null;

                    await createNotification(
                        notification.message,
                        headquartersId,
                        departmentId,
                        userIds
                    )
                        .then(() => {
                            this.$refs.newNotification.hide();
                            this.$_notificationMixin_success('Operación completada', 'La notificación ha sido enviada')
                            this.getAllNotifications();
                        })
                        .catch(() => {
                            this.$_notificationMixin_error('Operación no completada', 'No se ha podido enviar la notificación')
                        });
                    this.$_loadingMixin_hideLoading();
                } else {
                    this.$_notificationMixin_error('Notificación no válida', 'Revise los campos')
                }
            },
            isValidNotification(notification) {
                return (
                    !!notification.message
                    && (
                        (
                            !!notification.headquarters
                            && !!notification.headquarters.uuid
                            && !!notification.department
                            && !!notification.department.uuid
                        ) || (
                            Array.isArray(notification.users)
                            && notification.users.length > 0
                        )
                    )
                );
            }
        }
    }

</script>